import React from "react";
import "./KpiCard.css"; // your custom styles

export default function KpiCard({ icon, title, value }) {
  return (
    <div className="kpi-card">
      <div className="kpi-card-header">
        <div className="kpi-card-wrapper"> 
          <img src={icon} alt="" className="kpi-card-icon" />
        </div>
        
        
      </div>
      <span className="kpi-card-title">{title}</span>
      <div className="kpi-card-value">{value}</div>
    </div>
  );
}